import * as bodymovin from 'bodymovin';

export class Bias {
  constructor(data, animationJson) {
    this.href = '/' + data.slug;
    Object.assign(this, data);
    this.animationJson = animationJson;
    this.isAnimating = false;
  }

  loadAnimation(container, autoplay = false) {
    this.animation = bodymovin.loadAnimation({
      container,
      renderer: 'svg',
      loop: false,
      animationData: this.animationJson
    });

    this.animation.addEventListener('enterFrame', () => this.isAnimating = true);
    this.animation.addEventListener('complete', () => this.isAnimating = false);
    this.animation.addEventListener('DOMLoaded', () => {
      if (autoplay) {
        this.goToAndPlay(0);
      } else {
        this.goToAndStop(Infinity);
      }
    });
  }

  isAnimating() {
    return this.isAnimating;
  }

  play() {
    this.goToAndPlay(0);
  }

  pause() {
    this.animation.pause();
  }

  goToAndPlay(value) {
    this.animation.goToAndPlay(value, true);
  }

  goToAndStop(value) {
    this.animation.goToAndStop(value, true);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/biases/Bias.js